import { useState } from "react";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import useModalSelecaoTalhoes from "../../../hooks/useModalSelecaoTalhoes";
import MapTalhao from "./MapTalhao";

import {
    MapContainer,
    CounterInformation,
    ToogleList,
    LegendInformation,
    LegendMap,
    LegendMapTitle,
    LegendMapContent,
    LegendMapItem,
    InformationColor,
    MapContent
 } from "./styles";
import ControlViewType from "../../maps/base-map/components/controls/ControlViewType";
import { CurrentViewTypeEnum } from "components/maps/base-map/typings";

type Props = {
    isCollapsedMap: boolean,
    setIsCollapsedMap: (value: boolean) => void
    listTalhoesLogicos: any[]
    listTalhoesLogicosMap: any[]
}


export function MapTalhoes({ listTalhoesLogicos, listTalhoesLogicosMap, isCollapsedMap, setIsCollapsedMap }: Props) {
  const { listTalhoesLogicos: listTalhoesLogicosSelecionados, geoJSON } = useModalSelecaoTalhoes();
  const [currentViewType, setCurrentViewType] = useState<CurrentViewTypeEnum>(CurrentViewTypeEnum.transparent);

  const talhoesSelecteds = listTalhoesLogicos?.filter((item: any) => {
    return listTalhoesLogicosSelecionados?.includes(item.talhaoId);
  });

  const counterTalhesHA = talhoesSelecteds?.reduce((acc, item) => acc + item.areaPlantadaHa, 0)?.toFixed(2);
  return(
      <MapContainer>
          <CounterInformation>
              <div>{talhoesSelecteds?.length}/{listTalhoesLogicos?.length}</div>
              <div>Selecionados</div>
              <div>{counterTalhesHA} ha</div>
          </CounterInformation>

          <ToogleList>
              <button onClick={() => setIsCollapsedMap(!isCollapsedMap)}>
              
              {isCollapsedMap ? 
                  (
                      <>
                          <MdVisibilityOff size={24} /> <span>Ocultar Lista</span>
                      </>
                  )
                :  (
                      <>
                          <MdVisibility size={24} /> <span>Exibir Lista</span>
                      </>
                  )
              }
              
              </button>
          </ToogleList>

        <LegendInformation>
          <LegendMap>
            <LegendMapTitle>Legenda do Mapa</LegendMapTitle>
            <LegendMapContent>
              <LegendMapItem>
                <InformationColor backgroundColor="#009157" borderColor="388E3C" />
                <span>Talhões Selecionados</span>
              </LegendMapItem>
              <LegendMapItem>
                <InformationColor backgroundColor="#E0E0E0" borderColor="#9E9E9E" />
                <span>Talhões Não Selecionados</span>
              </LegendMapItem>
            </LegendMapContent>
          </LegendMap>
        </LegendInformation>

        <MapContent>
          <MapTalhao
             currentType={currentViewType}
             unidadeGeoJSON={geoJSON}
             talhoes={listTalhoesLogicosMap}
           />
        </MapContent>
        <div style={{position: 'absolute', bottom: 120, right: 15}}>
          <ControlViewType
            currentType={currentViewType}
            handleChange={setCurrentViewType}
          />

        </div>
      </MapContainer>
  );
}